<template>
  <ranking-page
    endpoint="/spontan/ranking/total/counts/month/finn"
    heading-danish="Rangliste - FiNN-tællinger seneste 30 dage"
    heading-english="Ranking - Total FiNN recent 30 days"
    is-finn
  />
</template>

<script>
import RankingPage from "./RankingPage.vue";

export default {
  components: { RankingPage },
};
</script>
